import { render, staticRenderFns } from "./YAxisExtSelector.vue?vue&type=template&id=1881cada&scoped=true"
import script from "./YAxisExtSelector.vue?vue&type=script&lang=js"
export * from "./YAxisExtSelector.vue?vue&type=script&lang=js"
import style0 from "./YAxisExtSelector.vue?vue&type=style&index=0&id=1881cada&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1881cada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1881cada')) {
      api.createRecord('1881cada', component.options)
    } else {
      api.reload('1881cada', component.options)
    }
    module.hot.accept("./YAxisExtSelector.vue?vue&type=template&id=1881cada&scoped=true", function () {
      api.rerender('1881cada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/componentStyle/YAxisExtSelector.vue"
export default component.exports